module.exports = __webpack_public_path__ + "static/img/9.70eee56.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/eng/9.png
// module id = Oqfu
// module chunks = 0